import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchSummary(action) {
  const { filtersString } = action.payload;
  try {
    const response = yield call(API.fetchTATMonitoringSummary, {
      filtersString
    });
    yield put(actions.fetchSummarySuccess(response.data));
  } catch (error) {
    yield put(actions.fetchSummaryFailure(error));
  }
}

export function* tatMonitoringSummarySaga() {
  yield takeLatest(actions.fetchSummary.type, handleFetchSummary);
}